// extracted by mini-css-extract-plugin
module.exports = {"invoiceNote":"_payment-InvoiceNote-module--invoice-note--3gUae"};